import { useRecoilValue } from "recoil";
import { LocaleAtom } from "../../../../state/localeAtom";

type TourStepContentProps = {
	description: React.ReactNode | (() => React.ReactNode);
};

const TourStepContent = ({ description }: TourStepContentProps) => {
	useRecoilValue(LocaleAtom);
	const content = typeof description === "function" ? description() : description;
	return (
		<div>
			<div>{content}</div>
		</div>
	);
};

export default TourStepContent;
